<template>
  <div style="height: 100%; position: relative;">
    
    <div class="screenWidth center" v-if="flag">
      <!-- V2 透明头部，叠加在海报区顶部 -->
    <div class="v2-header" v-if="$isV2">
      <div class="v2-header-inner screenWidth">
        <div class="v2-header-left">
          <img class="v2-logo" :src="logoImg" alt="">
        </div>
        <div class="v2-header-right">
          <div class="v2-time-hm">{{ timeHM }}</div>
          <div class="v2-time-mdw">{{ timeMDW }}</div>
        </div>
      </div>
    </div>
      <el-carousel :interval="interval" arrow="always" indicator-position="outside">
        <el-carousel-item v-for="(item, index) in imgList" :key="index">
          <img :src="item.mynameimg" alt="" width="100%">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div id="app" :style="{'height': flag ? '1220px':'100%'}">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import {
  api_banner
} from '@/api/home';
export default {
  name: 'App',
  data() {
    return {
      onLine: navigator.onLine,
      flag: false,
      interval: 5000,
      imgList:[],
      timeHM: '',    // 时分（如 14:30）
      timeMDW: '',   // 月日周（如 3月5日 周三）
    };
  },
  computed: {
    logoImg() {
      return this.$store.state.user.platformSettings.length && this.$store.state.user.platformSettings.find(el => el.name == 'XCXorH5homepageLogoURL').value
    }
  },
  mounted () {
    // window.googleBrower.checkShell("123")
    window.addEventListener('unload', this.saveState);
    window.addEventListener('online',  this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
    const screenHeight = window.screen.height;
    // const screenWidth = window.screen.width;
    // console.log(screenHeight,'----------screenHeight',screenWidth);
    if(screenHeight == 1920){
      this.flag = true;
    }
    this.getBanner()
    // V2 启动时间定时器
    if (this.$isV2) {
      this.setNowTimes()
      this.timer = setInterval(() => {
        this.setNowTimes()
      }, 1000)
    }
  },
  beforeDestroy(){
    window.removeEventListener('online',  this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    saveState () {
      sessionStorage.setItem('state', JSON.stringify(this.$store.state))
    },
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === 'online';
      localStorage.setItem('lineType', e.type)
      if(e.type === 'offline'){
        this.$router.push({name: "OffLine"});
      }
      // else{
      //   this.$router.push({name: "MyHome"});
      // }
    },
    getBanner() {
      const params = {
        groupcode: this.$store.state.user.groupcode
      }
      api_banner(params).then(res => {
        if (res.code == '0') {
        this.imgList = res.data
        }
      })
    },
    // 更新时间显示：上方时分，下方月日周
    setNowTimes() {
      const myDate = new Date();
      const month = myDate.getMonth() + 1;
      const date = myDate.getDate();
      const hou = myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours();
      const min = myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes();
      const weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      const week = weeks[myDate.getDay()];
      this.timeHM = hou + ':' + min;
      this.timeMDW = month + '月' + date + '日 ' + week;
    },
 },
}
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  text-align: center;
  height: 100%;
  width: 100%;
  background: #d3d3d3 url("~@/assets/img/bj.png") no-repeat;
}
.el-carousel__container {
  position: relative;
  height: 700px !important;
  margin-bottom: 50px;
  text-align: center;
}
.el-carousel__container{
  margin-bottom: 0;
}

.el-carousel__indicators--outside {
  bottom: 26px;
  text-align: center;
  transform: none;
  position: absolute !important;
  left: 0 !important;
  right: 0 !important;
}
.screenWidth{
  margin: 0 auto;
}
.center{
  margin: auto;
}

/* V2 透明叠加头部 */
.v2-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 120px;
  z-index: 100;
  /* 半透明黑色渐变遮罩：顶部深，底部透明 */
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  pointer-events: none;
}
.v2-header-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 40px;
  box-sizing: border-box;
}
.v2-header-left {
  display: flex;
  align-items: center;
}
.v2-logo {
  width: 400px;
  max-height: 80px;
  object-fit: contain;
}
.v2-header-right {
  text-align: right;
  color: #fff;
}
.v2-time-hm {
  font-size: 36px;
  font-weight: bold;
  line-height: 1.2;
}
.v2-time-mdw {
  font-size: 20px;
  opacity: 0.85;
  line-height: 1.5;
}
</style>

